module.exports = __webpack_public_path__ + "static/media/logo.b38ab4ac.png";